import { withInstall } from '@element-plus/utils'

import Slider from './src/slider.vue'

export const ElSlider = withInstall(Slider)
export default ElSlider

export * from './src/slider'
